export const environment = {
  production: true,
  api: 'https://uat.sso-api.logistics.rtp-eservice.com',
  ptsApi: 'https://uat.pts-api.logistics.rtp-eservice.com',
  appVersion: "ums",
  USERDATA_KEY: "9a5f56ffc495",
  portal: 'https://uat.lpms.logistics.rtp-eservice.com',
  prrApi: 'https://uat.prr-api.logistics.rtp-eservice.com',
  pcmApi: 'https://uat.pcm-api.logistics.rtp-eservice.com',
  ctmApi: 'https://uat.ctm-api.logistics.rtp-eservice.com/api',
  prmApi: 'https://uat.prm-api.logistics.rtp-eservice.com',
};
